import { render, staticRenderFns } from "./addRole.vue?vue&type=template&id=74ea4d54&scoped=true&"
import script from "./addRole.vue?vue&type=script&lang=js&"
export * from "./addRole.vue?vue&type=script&lang=js&"
import style0 from "./addRole.vue?vue&type=style&index=0&id=74ea4d54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ea4d54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74ea4d54')) {
      api.createRecord('74ea4d54', component.options)
    } else {
      api.reload('74ea4d54', component.options)
    }
    module.hot.accept("./addRole.vue?vue&type=template&id=74ea4d54&scoped=true&", function () {
      api.rerender('74ea4d54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/subrole/components/addRole.vue"
export default component.exports